import { Directive, Input, OnInit, OnDestroy } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { SavedSearchComponent } from '../../components/saved-search/saved-search.component';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appSavedSearchSync]'
})
export class SavedSearchSyncDirective implements OnInit, OnDestroy {
  @Input('appSavedSearchSync') savedSearchComponent!: SavedSearchComponent;
  
  private subs = new Subscription();

  constructor(private hostGrid: AgGridAngular) {}

  ngOnInit() {
    if (!this.hostGrid || !this.savedSearchComponent) return;

    this.subs.add(this.hostGrid.gridReady.subscribe((event: any) => {
      this.savedSearchComponent.refresh(event.api);
    }));

    this.subs.add(this.hostGrid.dragStopped.subscribe((event: any) => {
      this.savedSearchComponent.handleGridEvent(event);
    }));

    this.subs.add(this.hostGrid.filterChanged.subscribe((event: any) => {
      this.savedSearchComponent.handleGridEvent(event);
    }));

    this.subs.add(this.hostGrid.columnVisible.subscribe((event: any) => {
      this.savedSearchComponent.handleGridEvent(event);
    }));

    this.subs.add(this.hostGrid.sortChanged.subscribe((event: any) => {
      this.savedSearchComponent.handleGridEvent(event);
    }));

    this.subs.add(this.hostGrid.columnResized.subscribe((event: any) => {
      if (event.finished) {
        this.savedSearchComponent.handleGridEvent(event);
      }
    }));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
